module.exports = __webpack_public_path__ + "static/media/horse.14f83545.mp3";